import { useNavigate, useLocation } from 'react-router-dom';
import useAuth from './useAuth';

const useCartGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Returns true if authenticated. If not, redirects to /login and returns false.
  const requireAuth = () => {
    if (!isAuthenticated) {
      navigate('/login', { state: { from: location } });
      return false;
    }
    return true;
  };

  return { requireAuth, isAuthenticated };
};

export default useCartGuard;
